/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { BusinessReportDeleteRequestToJSON, BusinessReportListRequestToJSON, BusinessReportStartRequestToJSON, BusinessReportStatusDTOFromJSON, InventoryDeletePreviewDTOFromJSON, PaginatedResponseBusinessReportRowDTOFromJSON, } from '../models/index';
/**
 *
 */
export class BusinessReportControllerApi extends runtime.BaseAPI {
    /**
     */
    async deleteBusinessReportSelectionRaw(requestParameters, initOverrides) {
        if (requestParameters['businessReportDeleteRequest'] == null) {
            throw new runtime.RequiredError('businessReportDeleteRequest', 'Required parameter "businessReportDeleteRequest" was null or undefined when calling deleteBusinessReportSelection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/business-report/delete`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessReportDeleteRequestToJSON(requestParameters['businessReportDeleteRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteBusinessReportSelection(requestParameters, initOverrides) {
        const response = await this.deleteBusinessReportSelectionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getBusinessReportStatusRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling getBusinessReportStatus().');
        }
        const queryParameters = {};
        if (requestParameters['marketplace'] != null) {
            queryParameters['marketplace'] = requestParameters['marketplace'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/business-report/status`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportStatusDTOFromJSON(jsonValue));
    }
    /**
     */
    async getBusinessReportStatus(requestParameters, initOverrides) {
        const response = await this.getBusinessReportStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listBusinessReportRowsRaw(requestParameters, initOverrides) {
        if (requestParameters['businessReportListRequest'] == null) {
            throw new runtime.RequiredError('businessReportListRequest', 'Required parameter "businessReportListRequest" was null or undefined when calling listBusinessReportRows().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/business-report/list`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessReportListRequestToJSON(requestParameters['businessReportListRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseBusinessReportRowDTOFromJSON(jsonValue));
    }
    /**
     */
    async listBusinessReportRows(requestParameters, initOverrides) {
        const response = await this.listBusinessReportRowsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async previewBusinessReportDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters['businessReportDeleteRequest'] == null) {
            throw new runtime.RequiredError('businessReportDeleteRequest', 'Required parameter "businessReportDeleteRequest" was null or undefined when calling previewBusinessReportDelete().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/business-report/delete-preview`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessReportDeleteRequestToJSON(requestParameters['businessReportDeleteRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InventoryDeletePreviewDTOFromJSON(jsonValue));
    }
    /**
     */
    async previewBusinessReportDelete(requestParameters, initOverrides) {
        const response = await this.previewBusinessReportDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async startBusinessReportRaw(requestParameters, initOverrides) {
        if (requestParameters['businessReportStartRequest'] == null) {
            throw new runtime.RequiredError('businessReportStartRequest', 'Required parameter "businessReportStartRequest" was null or undefined when calling startBusinessReport().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/business-report/sync`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessReportStartRequestToJSON(requestParameters['businessReportStartRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessReportStatusDTOFromJSON(jsonValue));
    }
    /**
     */
    async startBusinessReport(requestParameters, initOverrides) {
        const response = await this.startBusinessReportRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetBusinessReportStatusMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
